const MAIN_TAB_ID_ARRAY = [0, 1, 2, 3, 5, 6, 12, 13, 14, 15, 16, 17, 18, 19, 20, 22];
const MIDDLE_CONTENT_PAGES = [13, 18, 19, 20]; // TOM
const EXCLUDE_TOP_BAR = [12]; // PX Dashboard

export { MAIN_TAB_ID_ARRAY, MIDDLE_CONTENT_PAGES, EXCLUDE_TOP_BAR };
